
import { Component, Input } from '@angular/core';
import { SkillsGroupViewModel } from '../../../shared/models/ReportModels';
import { MatDividerModule } from '@angular/material/divider';


@Component({
    selector: 'app-report-overall-skillsgroup',
    imports: [MatDividerModule],
    templateUrl: './report-overall-skillsgroup.component.html',
    styleUrl: './report-overall-skillsgroup.component.css'
})
export class ReportOverallSkillsgroupComponent {
  @Input() SkillsGroups: SkillsGroupViewModel[];

  classesRankingBox: string[] = ['grayshading','redshading','yellowshading', 'greenshading', 'lightgreenshading','blueshading' ];
  
}
